import React, { useState } from 'react';
import Modal from '../../../components/modal/modal';
import Input from '../../../components/input/input';
import Dropdown from '../../../components/dropdown/dropdown';
import Icon from '../../../components/icon/icon';
import { CheckCircle, Question, X } from '@phosphor-icons/react';
import { indianStates } from '../../event-create/components/step-4/indianStates';
import { ADDRESS_FIELDS, GROUPED_FIELDS, ORG_KEY_FIELD_MAPPING } from '../constants';
import '../style';

const DetailsEdit = (props) => {
  const {
    isOpen,
    handleSave,
    onClose,
    formData,
    onChangeData,
    handleStateChange,
    fieldsToEdit,
    editButtonIndex,
    formatAadharNumber,
  } = props;

  const [errors, setErrors] = useState({});

  const validateField = (field, value) => {
    let error = '';
    if (!value) {
      error = `${field} cannot be empty`;
    } else if (field === 'aadhar' && !/^\d{12}$/.test(value.replace(/\s+/g,''))) {
      error = 'Aadhar number must be 12 digits';
    } else if (field === 'pan' && !/^[A-Z]{5}[0-9]{4}[A-Z]$/.test(value)) {
      error = 'PAN must follow the format 5 letters, 4 numbers, 1 letter';
    } else if (field === 'gst' && !/^\d{2}[A-Z]{5}[0-9]{4}[A-Z][1-9A-Z]Z[0-9A-Z]$/.test(value)) {
      error = 'GST must follow the format 2 digits, PAN format, 1 digit, Z, 1 digit';
    }
    return error;
  };

  const handleValidation = (e, field, valueKey) => {
    const { value } = e.target;
    const error = validateField(field, value);
    setErrors({ ...errors, [field]: error });
    onChangeData(e, valueKey || field);
  };

  const handleSaveWithValidation = () => {
    const newErrors = {};
    fieldsToEdit.forEach((field) => {
      const fieldKey = ORG_KEY_FIELD_MAPPING[field] || field;
      const error = validateField(field, ADDRESS_FIELDS.includes(fieldKey) ? formData?.address_details?.[fieldKey] : formData[fieldKey]);
      if (error) newErrors[field] = error;
    });
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
    } else {
      handleSave();
    }
  };

  return (
    <div>
      <Modal
        isOpen={isOpen}
        primaryText={GROUPED_FIELDS[editButtonIndex].includes('aadhar') || GROUPED_FIELDS[editButtonIndex].includes('gst')  ? 'Next' : 'Save'}
        secondaryText={null}
        onClickPrimaryCta={handleSaveWithValidation}
        onClickSecondaryCta={onClose}
        className={`${fieldsToEdit.includes('contact_first_name') ? 'edit-bio' :
          fieldsToEdit.includes('company_name') ? 'details-edit' :
            fieldsToEdit.includes('aadhar') ? 'edit-aadhar' :
              'details-edit'} secondary-cta-hidden gap-8`}
        size="medium"
        title={<div className='flex w-full justify-between'><div> {fieldsToEdit.includes('aadhar') ? 'Edit Aadhar details' :
          fieldsToEdit.includes('gst') ? 'Edit GST details' :
            'Edit details'}</div><Icon type='circle' 
          onClick={onClose}><X size={16}  
            color='#101010' /></Icon></div>}
      >
        <div className= 'flex flex-col gap-8'>
          {GROUPED_FIELDS[editButtonIndex].map((field) => {
            if (field === 'contact_first_name') {
              return (
                <Input
                  key={field}
                  label="Display Name"
                  value={formData.contact_first_name || formData.name || ''}
                  onChange={(e) => handleValidation(e, 'contact_first_name')}
                  width={'100%'}
                  validationStatus = {errors.contact_first_name ? 'error' : ''}
                  helpText={errors.contact_first_name}
                />
              );
            } else if (field === 'note') {
              return (
                <Input
                  key={field}
                  label="Bio"
                  value={formData.note || ''}
                  onChange={(e) => handleValidation(e, 'note')}
                  width={'100%'}
                  placeholder='Add bio'
                />
              );
            } else if (field === 'company_name') {
              return (
                <Input
                  key={field}
                  label="Registered Company name/Organizer’s name"
                  value={formData.company_name || ''}
                  onChange={(e) => handleValidation(e, 'company_name')}
                  width={'100%'}
                  validationStatus = {errors.company_name ? 'error' : ''}
                  helpText={errors.company_name}
                />
              );
            } else if (field === 'address_line_1') {
              return (
                <Input
                  key={field}
                  label="Address"
                  value={formData.address_details?.address_line_1 || ''}
                  onChange={(e) => handleValidation(e, 'address_line_1')}
                  width={'100%'}
                  validationStatus = {errors.address_line_1 ? 'error' : ''}
                  helpText={errors.address_line_1}
                />
              );
            } else if (field === 'state') {
              return (
                <Dropdown
                  key={field}
                  label="State"
                  labelIcon={<Question size={16} 
                    color="#878787" 
                    className='mt-1' />}
                  width={'100%'}
                  options={indianStates}
                  hasSearch={true}
                  value={formData.address_details?.state || ''}
                  onChange={handleStateChange}
                  error={errors.state}
                />
              );
            } else if (field === 'aadhar') {
              return (
                <div className='relative'> 
                  <Input
                    key={field}
                    className='relative'
                    label="Aadhar number"
                    labelIcon={<Question size={16} 
                      color="#878787" 
                      className='mt-1' />}
                    width={'100%'}
                    maxLength={14}
                    value={formatAadharNumber(formData.proof_data || '')}
                    onChange={(e) => {
                      const aadharValue = e.target.value.replace(/\s+/g,'');
                      const formattedAadhar = formatAadharNumber(aadharValue);
                      handleValidation({target : {value : formattedAadhar}}, 'aadhar', 'proof_data');
                    }}
                    validationStatus = {errors.aadhar ? 'error' : ''}
                    helpText={errors.aadhar}
                  />
                  {formData.proof_data && !errors.aadhar && (
                    <CheckCircle
                      size={24}
                      color={'#009D64'}
                      weight={'fill'}
                      className="absolute right-4 top-14 transform -translate-y-1/2"
                    />
                  )}
                </div>
              );
            } else if (field === 'pan') {
              return (
                <Input
                  key={field}
                  label="PAN number"
                  labelIcon={<Question size={16} 
                    color="#878787" 
                    className='mt-1' />}
                  width={'100%'}
                  value={(formData?.proof_data ? 
                    formData?.proof_data : 
                    formData?.alternate_proof_data ? 
                      formData?.alternate_proof_data : 
                      ''
                    ).toUpperCase()
                  }
                  onChange={(e) =>{
                    const upperCaseValue = e.target.value.toUpperCase(); 
                    handleValidation({ target: { value: upperCaseValue } }, formData?.proof_data? 'pan' : 'pan_registered', formData?.proof_data ?'proof_data': 'alternate_proof_data');
                  }}
                  validationStatus = {errors.pan ? 'error' : ''}
                  helpText={errors.pan}
                />
              );
            } else if (field === 'gst') {
              return (
                <div className='relative'> 
                  <Input
                    key={field}
                    className='relative'
                    label="GSTIN number"
                    labelIcon={<Question size={16} 
                      color="#878787" 
                      className='mt-1' />}
                    width={'100%'}
                    value={(formData.proof_data || '').toUpperCase()}
                    onChange={(e) => {
                      const upperCaseValue = e.target.value.toUpperCase(); 
                      handleValidation({ target: { value: upperCaseValue } }, 'gst', 'proof_data');
                    }}
                    validationStatus = {errors.gst ? 'error' : ''}
                    helpText={errors.gst}
                  />
                  {formData.proof_data && !errors.gst && (
                    <CheckCircle
                      size={24}
                      color={'#009D64'}
                      weight={'fill'}
                      className="absolute right-4 top-14 transform -translate-y-1/2"
                    />
                  )}
                </div>
              );
            }
            return null;
          })}
        </div>
      </Modal>
    </div>
  );
};

export default DetailsEdit;
